import { bindTypesToActions } from '@src/utils/redux_utils';

const types = {
  SetRewards: 'REWARDS_SET_REWARDS',
  SetListeners: 'REWARDS_SET_LISTENERS',  
  SetBadges: 'REWARDS_SET_BADGES',
  SetCertificates: 'REWARDS_SET_CERTIFICATES',
  SetAvatars: 'REWARDS_SET_AVATARS',
  ClearAll: 'REWARDS_CLEAR_ALL'
};

const RewardsActions = bindTypesToActions( types );

const initialState = {
    rewards: null,
    badges:null,
    certificates: null,
    avatars: null
};

const RewardsReducer = (state = initialState, { type, payload }) => {
  
  switch (type) {

    case types.SetRewards: 
        const value = payload ? Number( payload ): 0 ;
        return ( state.rewards === value ) ? state : { ...state, rewards: [ value ] } ;
  
    case types.SetBadges: 
        return Array.isArray( payload ) ? { ...state, badges: [ ...payload ] } : state ;   

    case types.SetCertificates: 
        return Array.isArray( payload ) ? { ...state, certificates: [ ...payload ] } : state;

    case types.SetAvatars:
        return Array.isArray( payload ) ? { ...state, avatars: [ ...payload ] } : state;
    
    case 'LOG_OUT_ALL':
    case 'PROFILE_CHOOSE_PROFILE':    
    case types.ClearAll: return { ...initialState } ;

    default:
      return state;
  }
};





export { types as RewardsTypes, RewardsReducer, RewardsActions };
